import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import TopNavigation from "./TopNavigaton";
import ActionSideBar from "../action-sidebar/ActionSideBar";
import { FabActionsProvider } from "../action-sidebar/FabActionsContext";
import PanelBar from "../panel-bar/PanelBar";

export function WebLayout() {
  return (
    <FabActionsProvider>
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        {/* Top Navigation Bar */}
        <TopNavigation />

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: "100%",
            minHeight: "calc(100vh - 64px)", // Subtract AppBar height
            backgroundColor: "background.default",
            overflow: "auto",
          }}
        >
          <Container
            maxWidth="lg"
            sx={{
              mt: 4,
              mb: 4,
              px: { xs: 2, sm: 3, md: 4 },
              mx: "auto",
              backgroundColor: "background.paper",
              borderRadius: 2,
              boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
              overflow: "hidden",
            }}
          >
            <Box sx={{ py: 3 }}>
              <Outlet />
            </Box>
          </Container>
          <ActionSideBar />
          <PanelBar />
        </Box>
      </Box>
    </FabActionsProvider>
  );
}

export default WebLayout;
